import template from './transferList.html';
import controller from './transferList.controller';

export const transferListComponent = {
  name: 'transferList',
  restrict: 'E',
  template,
  bindings: {
    list: '<',
    translateKey: '@',
    collapse: '<',
    columns: '<',
  },
  controllerAs: 'vm',
  controller,
};



// WEBPACK FOOTER //
// ./src/app/components/overview/components/transferList/transferList.component.js